import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-crack-comments-dialog',
  templateUrl: './crack-comments-dialog.component.html',
  styleUrls: ['./crack-comments-dialog.component.scss']
})
export class CrackCommentsDialogComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<CrackCommentsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,) { }

    Crackcomment:string=""
  ngOnInit() {
    this.Crackcomment=this.data.Crackcomment
  }


  onCloseClick(){
    this.dialogRef.close()
  }
}
